export default __webpack_public_path__ + "images/R2.802030f.png";